import React from 'react';
import { LuClockAlert } from 'react-icons/lu';
import { getTodayISO, formatDateISO } from '../../utils/dateUtils';
import { FRANJAS, proximaFranjaHoy, etiquetaFranja } from '../../utils/franjas';

// Aviso cuando el día u horario que se está eligiendo ya pasó (15-oct-2026). Pasaba que se
// armaba un trabajo "para hoy a la mañana" a las 15 h: quedaba agendado en el pasado y no se
// notaba. No bloquea nada: avisa y ofrece pasarlo a más tarde o a mañana.
// Franjas de 2 h de 8 a 16 (20-oct-2026, utils/franjas): "Pasar a más tarde" lleva a la próxima franja de hoy.
const FIN = { Mañana: 13 * 60, Tarde: 19 * 60 };   // horas viejas guardadas como "Mañana"/"Tarde"
const ahoraMin = () => { const d = new Date(); return d.getHours() * 60 + d.getMinutes(); };
const aMin = (h) => { const [hh, mm] = String(h).split(':').map(Number); return hh * 60 + (mm || 0); };

/** Qué ya pasó de un día/horario, o null. hora: "HH:MM", "Mañana", "Tarde" o vacío. */
export function horarioPasado(fecha, hora, franja = null) {
    if (!fecha) return null;
    const hoy = getTodayISO();
    if (fecha < hoy) return { tipo: 'dia', texto: 'Ese día ya pasó.' };
    if (fecha > hoy) return null;
    const ahora = ahoraMin();
    const rango = /^(\d{1,2}:\d{2})\s*-\s*(\d{1,2}:\d{2})$/.exec(String(hora || ''));
    if (rango) return aMin(rango[2]) <= ahora ? { tipo: 'hora', texto: `El horario de hoy (hasta las ${rango[2]}) ya pasó.` } : null;
    if (hora && /^\d{1,2}:\d{2}/.test(hora)) {
        // 29-oct-2026: una hora puntual cuenta como su franja de 2 h (las 10:00 → de 10 a 12). Antes, a las
        // 10:02 ya decía "las 10:00 ya pasaron" aunque la franja seguía.
        const m = aMin(hora);
        const fr = FRANJAS.find(f => m >= f.desde && m < f.hasta);
        const fin = fr ? fr.hasta : m + 120;
        return fin <= ahora ? { tipo: 'hora', texto: fr ? `La franja de ${fr.rango} de hoy ya pasó.` : `Las ${String(hora).slice(0, 5)} de hoy ya pasaron.` } : null;
    }
    if (franja && /^\d{1,2}:\d{2}\s*-/.test(franja)) {
        const r = /-\s*(\d{1,2}:\d{2})$/.exec(franja);
        if (r) return aMin(r[1]) <= ahora ? { tipo: 'hora', texto: `La franja de hoy (hasta las ${r[1]}) ya pasó.` } : null;
    }
    const fr = /tarde/i.test(hora || franja || '') ? 'Tarde' : (hora || franja) ? 'Mañana' : null;
    if (fr && ahora >= FIN[fr]) return { tipo: 'franja', texto: `La ${fr.toLowerCase()} de hoy ya pasó.` };
    return null;
}

export default function AvisoHoraPasada({ fecha, hora, franja = null, onManana, onTarde }) {
    const p = horarioPasado(fecha, hora, franja);
    if (!p) return null;
    const proxima = fecha === getTodayISO() ? proximaFranjaHoy() : null;
    const tardeLibre = !!proxima && proxima !== franja;
    const manana = () => { const d = new Date(); d.setDate(d.getDate() + (d.getDay() === 6 ? 2 : 1)); return formatDateISO(d); };
    const btn = 'h-8 px-3 rounded-lg bg-card text-label font-black text-ink active:scale-95';
    return (
        <div className="p-3 rounded-xl bg-[color:var(--warning-bg,rgba(234,179,8,0.12))] text-caption text-ink space-y-2" role="alert">
            <p className="flex items-start gap-1.5">
                <LuClockAlert size={15} className="mt-px shrink-0 text-[var(--warning-tx)]" />
                <span><b>{p.texto}</b> Si el trabajo ya se hizo, esto queda como una carga de algo pasado (no hace falta mandar al técnico).
                    Si todavía no se hizo, pasalo para más tarde.</span>
            </p>
            {(onTarde || onManana) && (
                <div className="flex flex-wrap gap-1.5">
                    {onTarde && tardeLibre && <button type="button" onClick={() => onTarde(proxima)} className={btn}>Pasar a más tarde ({etiquetaFranja(proxima)})</button>}
                    {onManana && <button type="button" onClick={() => onManana(manana())} className={btn}>Pasar a mañana</button>}
                </div>
            )}
        </div>
    );
}
